import {Component, Input, OnInit} from '@angular/core';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

type pageTypes = 'type_input' | 'value_input';
type inputTypes = 'file_upload' | 'enter_code';

@Component({
  selector: 'import-opeanapi-file',
  templateUrl: './import-opeanapi-file.component.html',
  styleUrls: ['./import-opeanapi-file.component.scss']
})
export class ImportOpeanapiFileComponent implements OnInit {

  @Input() fileType: any;

  code: any;

  @Input() fileTypes = [
    {
      'type': 'json',
      'display_name': 'JSON'
    },
    {
      'type': 'yaml',
      'display_name': 'YAML'
    }
  ];

  selectedFileType: String = 'yaml';

  currentPage: pageTypes = 'type_input';
  inputType: inputTypes;
  isUploadDisabled = false;
  link: string;

  filePreviewModeActive = false;

  file: any;
  progress = 0;

  constructor(public platform: LeftpanelComponent) { }

  ngOnInit() {
  }

  fileBrowseHandler(file) {
    this.file = file[0];
    this.progress = 0;
    // console.log(this.file);
    this.handleFileAfterUpload();
  }

  onFileDropped(file) {
    this.file = file[0];
    this.progress = 0;
    // console.log(this.file);
    this.handleFileAfterUpload();
  }

  handleFileAfterUpload() {
    Promise.resolve(this.processFile(this.file)).then(response => {
      // console.log(response);
      if (response) {
        this.filePreviewModeActive = true;
        this.code = response;
      }
    }, error => {
      if (error) {
        this.platform.openSnackBar(error, 'Error', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    });
  }

  processFile (file) {
    return new Promise((resolve, reject) => {
      if (file) {
        if (file.type === 'application/x-yaml' || file.type === 'application/json') {
          const reader = new FileReader();
          if (file.type === 'application/json') {
            reader.addEventListener('load', (event: any) => {
              try {
                resolve(JSON.parse(event.target.result.toString()));
              } catch (e) {
                reject('Please upload a valid JSON file.');
              }
            });
          } else {
            reader.addEventListener('load', (event: any) => {
              resolve(event.target.result.toString());
            });
          }
          reader.readAsText(file);
        } else {
          reject('Please upload a valid JSON or YAML file.');
        }
      } else {
        reject();
      }
    });
  }

  removeFile(returnToMainPage = false) {
    if (returnToMainPage) {
      this.currentPage = 'type_input';
    }
    this.file = null;
    this.filePreviewModeActive = false;
    this.code = null;
  }
}
